import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Checkbox,
  Divider,
  Fieldset,
  Flex,
  Grid,
  Group,
  Menu,
  NumberInput,
  ScrollArea,
  Select,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import cx from "clsx";
import { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import classes from "../../../Styles/TableScrollArea.module.css";
import {
  convertCamelCase,
  removeVietnameseTones,
} from "../../../_base/helper/FunctionHelper";
import { modals } from "@mantine/modals";
import { IconCheck, IconTrash, IconWindow } from "@tabler/icons-react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

interface Delivery {
  deliveryId: number;
  durationEstimated: number;
  distanceEstimated: number;
  isPayroll: boolean;
}

interface Employee {
  employeeId: number;
  employeeName: string;
  mobileNumber: string;
  isMainResponsibility: boolean;
  isDriver: boolean;
  isPayroll: boolean;
  attributes: any;
}

interface DeliveryAssignmentV3 {
  code: string | null;
  typeAssignment: string | null;
  vehicleCode: string | null;
  isDeliveryOnSite: boolean;
  distance: number | null;
  distanceTotal: number | null;
  estimatedTime: number | null;
  fromExpectedDate: string | null;
  toExpectedDate: string | null;
  description: string | null;
  deliveryIdForCombine: number | null;
  deliveries: Delivery[];
  employees: Employee[];
}

const AssignmentOfInstallation = ({
  dataDeliverySelect,
  onClose,
  typeDelivery,
  department,
}: {
  dataDeliverySelect: any[];
  onClose: any;
  typeDelivery: string;
  department: string;
}) => {
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [scrolled, setScrolled] = useState(false);
  const [scrolledTableEmployeeSelect, setScrolledTableEmployeeSelect] =
    useState(false);

  const [dataAddress, setDataAddress] = useState<any[]>([]);
  const [searchEmployee, setSearchEmployee] = useDebouncedState<string>(
    "",
    300,
  );

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [dataEmployeeTemp, setDataEmployeeTemp] = useState<any[]>([]);
  const [dataDeliveryWork, setDataDeliveryWork] = useState<any[]>([]);

  const form = useForm<DeliveryAssignmentV3>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      // id: 0,
      // assignmentDate: new Date(
      //   new Date().getTime() + 7 * 3600 * 1000,
      // ).toISOString(),
      // vehicleCode: typeDelivery === "DONG_GOI" ? null : "XE_MAY",
      // fromExpectedDate: dataDeliverySelect[0]?.fromDeliveryDate,
      // toExpectedDate: dataDeliverySelect[0]?.deliveryAppointmentTime,

      // deliveries: [],
      code: null,
      typeAssignment: typeDelivery,
      vehicleCode: typeDelivery === "DONG_GOI" ? null : "XE_MAY",
      isDeliveryOnSite: false,
      distance: null,
      distanceTotal: null,
      estimatedTime: null,
      fromExpectedDate: null,
      toExpectedDate: null,
      description: null,
      deliveryIdForCombine: null,
      deliveries: [],
      employees: [],
    },

    validate: {},
  });

  const customHeightTable = () => {
    if (dataDeliverySelect.length === 1) {
      return 110;
    } else if (dataDeliverySelect.length === 2) {
      return 150;
    } else if (dataDeliverySelect.length === 3) {
      return 190;
    } else {
      return 230;
    }
  };

  const getCreateDeliveryAssignment = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDeliveryAssignment/create?prefix=VD-",
    );

    if (res && res.success) {
      const data = res.data;
      if (data) {
        form.setValues((prev) => ({ ...prev, code: data.code }));
      }
    }
  };

  const handleCalculateDistance = async () => {
    const dataAddressCalculate = dataDeliverySelect
      ?.filter(
        (i) =>
          i.id &&
          i.fromAddress &&
          i.toAddress &&
          String(i.fromAddress).length > 0 &&
          String(i.toAddress).length > 0,
      )
      ?.map((i) => ({
        id: i.id,
        fromAddress: i.fromAddress,
        toAddress: i.toAddress,
      }));

    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/VietMap/calculate-distance-one-to-one",
      {
        sourceAddresses: dataAddressCalculate.map((i) => i.fromAddress),
        destinationAddresses: dataAddressCalculate.map((i) => i.toAddress),
      },
    );

    if (res && res.success) {
      const result = res.data?.routes;
      const filterDataAPI = dataDeliverySelect.map((item) => {
        const matchingItem = result.find(
          (i: any) =>
            i.sourceAddress === item.fromAddress &&
            i.destinationAddress === item.toAddress,
        );

        if (matchingItem && item.attribute25 !== "NX") {
          return {
            ...item,
            distanceKm: matchingItem.distanceKm,
            durationMinutes: matchingItem.durationMinutes,
            durationSeconds: matchingItem.durationSeconds,
            distanceMeters: matchingItem.distanceMeters,
          };
        } else if (item.attribute25 === "NX") {
          return {
            ...item,
            distanceKm: Number(item.attribute26),
            durationMinutes: Number(item.attribute26) * 2,
            durationSeconds: Number(item.attribute26) * 120,
            distanceMeters: Number(item.attribute26) * 1000,
          };
        }

        return item;
      });

      setDataAddress(filterDataAPI);
      form.setValues((prev) => ({
        ...prev,
        distance:
          typeDelivery === "GHEP_DON" || typeDelivery === "DONG_GOI"
            ? 0
            : filterDataAPI.reduce((sum, i) => {
                return sum + i.distanceMeters;
              }, 0),
        distanceTotal:
          typeDelivery === "GHEP_DON" || typeDelivery === "DONG_GOI"
            ? 0
            : filterDataAPI.reduce((sum, i) => {
                return sum + i.distanceMeters;
              }, 0),
        estimatedTime:
          typeDelivery === "GHEP_DON" || typeDelivery === "DONG_GOI"
            ? 0
            : filterDataAPI.reduce((sum, i) => {
                return sum + i.durationSeconds;
              }, 0),
        deliveries: filterDataAPI.map((i) => ({
          deliveryId: Number(i.id),
          durationEstimated:
            typeDelivery === "DONG_GOI" ? 0 : i.durationSeconds,
          distanceEstimated: typeDelivery === "DONG_GOI" ? 0 : i.distanceMeters,
          isPayroll: false,
        })),
      }));
    } else {
      setDataAddress([]);
    }
  };

  const getDataEmployeeDelievry = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/get-list?Take=200&depType=${department}`,
    );

    if (res && res?.success) {
      const data = res.data
        .filter((item: any) => item.fullname && item.id && item.active)
        .map((item: any) => ({
          value: item.id?.toString(),
          label: `${item.fullname} - ${item.code}`,
          departmentName: item.departmentName,
          roleName: item.roleName,
          mobileNumber: item.phoneNumber,
        }));

      setDataEmployee(data);
      setDataEmployeeTemp(data);
    }
  };

  const getDataDeliveryWork = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmDeliveryWork/get-all",
    );

    if (res && res.success) {
      const result = res.data;

      setDataDeliveryWork(
        result
          .filter(
            (item: any) =>
              item.name &&
              item.id &&
              item.active &&
              item.department &&
              item.department?.includes(String(department)),
          )
          .map((item: any) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const handleAssignV3 = async (dataSubmit: DeliveryAssignmentV3) => {
    open();

    const invalidEmployees = dataSubmit.employees.filter((employee) => {
      const attributes = employee.attributes;
      if (!attributes) return false;

      const keysToCheck = Object.keys(attributes).filter(
        (key) => key !== "tongSoLuongHang",
      );

      return (
        keysToCheck.length > 0 &&
        keysToCheck.every((key) => attributes[key] === null)
      );
    });

    if (invalidEmployees && invalidEmployees.length > 0) {
      NotificationExtension.Fails(
        `Các nhân viên ${invalidEmployees.map((i) => i.employeeName).join(", ")} chưa được phân công công việc !`,
      );
      close();
      return;
    }

    if (!dataSubmit.employees || dataSubmit.employees.length === 0) {
      NotificationExtension.Fails(
        "Vui lòng chọn nhân viên giao hàng và lắp đặt !",
      );
      close();
      return;
    }

    if (!dataSubmit.employees.some((i) => i.isMainResponsibility === true)) {
      NotificationExtension.Fails("Vui lòng chọn người chịu trách nhiệm !");
      close();
      return;
    }

    if (
      dataSubmit.employees.filter((i) => i.isMainResponsibility === true)
        .length > 1
    ) {
      NotificationExtension.Fails(
        "Chỉ được phép chọn 1 người chịu trách nhiệm !",
      );
      close();
      return;
    }

    if (!dataSubmit.employees.some((i) => i.isDriver === true)) {
      NotificationExtension.Fails("Vui lòng chọn người lái xe !");
      close();
      return;
    }

    if (dataSubmit.employees.filter((i) => i.isDriver === true).length > 1) {
      NotificationExtension.Fails("Chỉ được phép chọn 1 người lái xe !");
      close();
      return;
    }

    // if (
    //   dataSubmit.employees.some(
    //     (i) =>
    //       !i.attributes?.tongSoLuongHang ||
    //       i.attributes?.tongSoLuongHang <= 0 ||
    //       isNaN(i.attributes?.tongSoLuongHang),
    //   )
    // ) {
    //   NotificationExtension.Fails(
    //     "Vui lòng nhập đầy đủ tổng số lượng hàng cho từng nhân viên được phân công !",
    //   );
    //   close();
    //   return;
    // }

    try {
      const res = await repositoryDelivery.post<MessageResponse<any>>(
        "/api/v1/TblDeliveryAssignment/create-v3",
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Phân công giao hàng và lắp đặt thành công !",
        );
        setTimeout(() => {
          modals.closeAll();
          onClose();
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    getCreateDeliveryAssignment();
    getDataEmployeeDelievry();
    getDataDeliveryWork();
  }, []);

  useEffect(() => {
    if (searchEmployee.length > 1) {
      const data = dataEmployeeTemp.filter((i) =>
        removeVietnameseTones(i.label).includes(
          removeVietnameseTones(searchEmployee),
        ),
      );

      setDataEmployee(data);
    } else {
      setDataEmployee(dataEmployeeTemp);
    }
  }, [searchEmployee]);

  useEffect(() => {
    if (dataDeliverySelect.length > 0) {
      handleCalculateDistance();
    } else {
      setDataAddress([]);
    }
  }, [dataDeliverySelect]);

  return (
    <Box
      mt={5}
      component="form"
      onSubmit={form.onSubmit((e: DeliveryAssignmentV3) => {
        handleAssignV3(e);
      })}
    >
      <Fieldset legend="Thông tin giao nhận" p={"0px 15px 7.5px 15px"} mt={5}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              key={form.key("code")}
              label="Mã phân công giao vận"
              placeholder="Nhập mã phân công giao vận"
              size="xs"
              variant="filled"
              readOnly
              {...form.getInputProps("code")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DateTimePicker
              label="Ngày phân công"
              placeholder="Nhập ngày phân công"
              value={new Date()}
              valueFormat="DD/MM/YYYY HH:mm A"
              size="xs"
              variant="filled"
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              label="Phương tiện giao hàng"
              placeholder="Chọn phương tiện giao hàng"
              clearable
              data={[
                { label: "Xe máy", value: "XE_MAY" },
                { label: "Ô tô", value: "O_TO" },
              ]}
              value={
                form.getValues().vehicleCode
                  ? form.getValues().vehicleCode?.toString()
                  : null
              }
              size="xs"
              {...form.getInputProps("vehicleCode")}
              onChange={(e) =>
                form.setValues((prev) => ({
                  ...prev,
                  vehicleCode: e ? e : "XE_MAY",
                }))
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              key={form.key("description")}
              size="xs"
              label="Ghi chú"
              placeholder="Ghi chú"
              {...form.getInputProps("description")}
            />
          </Grid.Col>
        </Grid>
      </Fieldset>
      <Fieldset legend="Nhân viên phân công" p={"0px 15px 7.5px 15px"} mt={5}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Menu trigger="hover" closeDelay={400}>
              <Menu.Target>
                <TextInput
                  label="Phân công nhân viên"
                  placeholder="Nhập tên hoặc mã nhân viên"
                  defaultValue={searchEmployee}
                  onChange={(e) => {
                    setSearchEmployee(e.currentTarget.value);
                  }}
                  size="xs"
                />
              </Menu.Target>
              <Menu.Dropdown>
                <ScrollArea
                  h={!dataEmployee || dataEmployee.length === 0 ? 70 : 300}
                  onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                >
                  <Table
                    striped
                    highlightOnHover
                    withTableBorder
                    withColumnBorders
                  >
                    <Table.Thead
                      className={cx(classes.header, {
                        [classes.scrolled]: scrolled,
                      })}
                    >
                      <Table.Tr>
                        <Table.Th></Table.Th>
                        <Table.Th>Nhân viên</Table.Th>
                        <Table.Th>Phòng ban</Table.Th>
                        <Table.Th>Chức vụ</Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {dataEmployee && dataEmployee.length > 0 ? (
                        dataEmployee.map((i: any) => (
                          <Table.Tr>
                            <Table.Td>
                              <Button
                                size="xs"
                                color={
                                  form
                                    .getValues()
                                    .employees.some(
                                      (item) => item.employeeId === i.value,
                                    )
                                    ? "red"
                                    : "teal"
                                }
                                onClick={() => {
                                  if (
                                    form
                                      .getValues()
                                      .employees.some(
                                        (item) => item.employeeId === i.value,
                                      )
                                  ) {
                                    const dataDelete = form
                                      .getValues()
                                      .employees.findIndex(
                                        (item) =>
                                          String(item.employeeId) ===
                                          String(i.value),
                                      );

                                    form.removeListItem(
                                      "employees",
                                      dataDelete,
                                    );
                                  } else {
                                    const result = dataDeliveryWork.reduce(
                                      (acc, currentItem) => {
                                        acc[
                                          convertCamelCase(currentItem.label)
                                        ] = null;
                                        return acc;
                                      },
                                      {},
                                    );

                                    form.insertListItem(
                                      "employees",
                                      form.getValues().employees.length === 0
                                        ? {
                                            employeeId: i.value,
                                            employeeName: i.label,
                                            mobileNumber: i.mobileNumber,
                                            isMainResponsibility: true,
                                            isDriver: true,
                                            isPayroll: true,
                                            attributes: {
                                              ...result,
                                            },
                                          }
                                        : {
                                            employeeId: i.value,
                                            employeeName: i.label,
                                            mobileNumber: i.mobileNumber,
                                            isMainResponsibility: false,
                                            isDriver: false,
                                            isPayroll: true,
                                            attributes: {
                                              ...result,
                                            },
                                          },
                                    );
                                  }
                                }}
                              >
                                {form
                                  .getValues()
                                  .employees.some(
                                    (item) => item.employeeId === i.value,
                                  )
                                  ? "Bỏ chọn"
                                  : "Chọn"}
                              </Button>
                            </Table.Td>
                            <Table.Td>{i.label}</Table.Td>
                            <Table.Td>{i.departmentName}</Table.Td>
                            <Table.Td>{i.roleName}</Table.Td>
                          </Table.Tr>
                        ))
                      ) : (
                        <Table.Tr>
                          <Table.Td colSpan={4} ta={"center"} h={"100%"}>
                            Không tìm thấy dữ liệu !
                          </Table.Td>
                        </Table.Tr>
                      )}
                    </Table.Tbody>
                  </Table>
                </ScrollArea>
              </Menu.Dropdown>
            </Menu>
          </Grid.Col>
        </Grid>
        {!form.getValues().employees ||
        form.getValues().employees.length === 0 ? (
          <Box ta={"center"}>
            <Divider mb="md" />
            <Text fw={500} size="16px" my={15}>
              Bạn chưa chọn nhân viên nào để phân công lắp đặt cho đơn hàng này
              !
            </Text>
            <Divider mb="md" />
          </Box>
        ) : (
          <ScrollArea
            h={300}
            onScrollPositionChange={({ y }) =>
              setScrolledTableEmployeeSelect(y !== 0)
            }
          >
            <Table striped highlightOnHover withTableBorder w={3200}>
              <Table.Thead
                className={cx(classes.header, {
                  [classes.scrolled]: scrolledTableEmployeeSelect,
                })}
              >
                <Table.Tr>
                  <Table.Th ta={"center"}>Nhân viên</Table.Th>
                  <Table.Th ta={"center"}>Người chịu trách nhiệm</Table.Th>
                  <Table.Th ta={"center"}>Lái xe</Table.Th>
                  <Table.Th ta={"center"}>Tính lương</Table.Th>
                  {/* <Table.Th ta={"center"}>Tổng số lượng hàng</Table.Th> */}
                  {dataDeliveryWork.map((iDW) => (
                    <Table.Th ta={"center"}>{iDW.label}</Table.Th>
                  ))}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {form.getValues().employees &&
                  form.getValues().employees.length > 0 &&
                  form.getValues().employees.map((i: any, index: number) => (
                    <Table.Tr>
                      <Table.Td ta={"center"}>{i.employeeName}</Table.Td>
                      <Table.Td>
                        <Flex justify={"center"}>
                          <Checkbox
                            key={form.key(
                              `employees.${index}.isMainResponsibility`,
                            )}
                            size="xs"
                            {...form.getInputProps(
                              `employees.${index}.isMainResponsibility`,
                              { type: "checkbox" },
                            )}
                          />
                        </Flex>
                      </Table.Td>
                      <Table.Td>
                        <Flex justify={"center"}>
                          <Checkbox
                            key={form.key(`employees.${index}.isDriver`)}
                            size="xs"
                            {...form.getInputProps(
                              `employees.${index}.isDriver`,
                              { type: "checkbox" },
                            )}
                          />
                        </Flex>
                      </Table.Td>
                      <Table.Td>
                        <Flex justify={"center"}>
                          <Checkbox
                            key={form.key(`employees.${index}.isPayroll`)}
                            size="xs"
                            {...form.getInputProps(
                              `employees.${index}.isPayroll`,
                              { type: "checkbox" },
                            )}
                          />
                        </Flex>
                      </Table.Td>
                      {/* <Table.Td>
                        <NumberInput
                          key={form.key(
                            `employees.${index}.attributes.tongSoLuongHang`,
                          )}
                          hideControls
                          allowNegative={false}
                          {...form.getInputProps(
                            `employees.${index}.attributes.tongSoLuongHang`,
                          )}
                          size="xs"
                        />
                      </Table.Td> */}
                      {Object.keys(i.attributes)
                        .filter((iFill) => String(iFill) !== "tongSoLuongHang")
                        .map((iMap) => (
                          <Table.Td>
                            <NumberInput
                              key={form.key(
                                `employees.${index}.attributes.${iMap}`,
                              )}
                              hideControls
                              allowNegative={false}
                              size="xs"
                              {...form.getInputProps(
                                `employees.${index}.attributes.${iMap}`,
                              )}
                            />
                          </Table.Td>
                        ))}
                      <Table.Td>
                        <Flex justify={"center"}>
                          <ActionIcon
                            color="red"
                            onClick={() => {
                              const dataSet = form
                                .getValues()
                                .employees.filter(
                                  (iFil) => iFil.employeeId !== i.employeeId,
                                );

                              const dataDelete = form
                                .getValues()
                                .employees.find(
                                  (iFind) => iFind.employeeId === i.employeeId,
                                );

                              if (dataSet.length > 0 && dataDelete) {
                                const firstItem = { ...dataSet[0] };
                                let isUpdated = false;

                                if (dataDelete.isMainResponsibility === true) {
                                  firstItem.isMainResponsibility = true;
                                  isUpdated = true;
                                }

                                if (dataDelete.isDriver === true) {
                                  firstItem.isDriver = true;
                                  isUpdated = true;
                                }

                                if (isUpdated) {
                                  dataSet[0] = firstItem;
                                }
                              }

                              form.setFieldValue("employees", dataSet);
                            }}
                          >
                            <IconTrash size={14} />
                          </ActionIcon>
                        </Flex>
                      </Table.Td>
                    </Table.Tr>
                  ))}
              </Table.Tbody>
            </Table>
          </ScrollArea>
        )}
      </Fieldset>
      {typeDelivery !== "DONG_GOI" && (
        <>
          <ScrollArea
            h={customHeightTable()}
            onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
          >
            <Table
              striped
              highlightOnHover
              withTableBorder
              withColumnBorders
              mt={10}
            >
              <Table.Thead
                className={cx(classes.header, {
                  [classes.scrolled]: scrolled,
                })}
              >
                <Table.Tr>
                  {typeDelivery === "GHEP_DON" ? (
                    <>
                      <Table.Th w={110}>Đơn tính lương</Table.Th>
                      <Table.Th w={110}>Mã đơn</Table.Th>
                      <Table.Th w={125}>Trạng thái đơn</Table.Th>
                    </>
                  ) : (
                    <></>
                  )}
                  <Table.Th>
                    {dataDeliverySelect.length > 1
                      ? "Danh sách điểm đi"
                      : "Điểm đi"}
                  </Table.Th>
                  <Table.Th>
                    {dataDeliverySelect.length > 1
                      ? "Danh sách điểm đến"
                      : "Điểm đến"}
                  </Table.Th>
                  <Table.Th>Quãng đường</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {dataAddress &&
                  dataAddress.length > 0 &&
                  dataAddress.map((i) => (
                    <Table.Tr key={i.id}>
                      {typeDelivery === "GHEP_DON" ? (
                        <>
                          <Table.Td>
                            <Checkbox
                              checked={
                                Number(i.id) ===
                                Number(form.getValues()?.deliveryIdForCombine)
                              }
                              disabled={
                                i?.statusId?.toString() === 9 ||
                                form.getValues()?.isDeliveryOnSite
                              }
                              onChange={() => {
                                form.setValues((prev) => ({
                                  ...prev,
                                  deliveryIdForCombine: Number(i.id),
                                  distance: Number(i.distanceMeters),
                                  distanceTotal: Number(i.distanceMeters),
                                  estimatedTime: Number(i.durationSeconds),
                                  deliveries: form
                                    .getValues()
                                    ?.deliveries?.map((i2: any) =>
                                      String(i2.deliveryId) === String(i.id)
                                        ? { ...i2, isPayroll: true }
                                        : { ...i2, isPayroll: false },
                                    ),
                                }));
                              }}
                            />
                          </Table.Td>
                          <Table.Td>{i?.sourceCode}</Table.Td>
                          <Table.Td>
                            <Badge
                              color={i?.statusId === 9 ? "yellow" : "blue"}
                            >
                              {i?.deliveryStatusName}
                            </Badge>
                          </Table.Td>
                        </>
                      ) : (
                        <></>
                      )}
                      <Table.Td>{i?.fromAddress}</Table.Td>
                      <Table.Td>
                        {i?.toAddress?.replace(/^(undefined|null) - /, "")}
                      </Table.Td>
                      <Table.Td>{i?.distanceKm} Km</Table.Td>
                    </Table.Tr>
                  ))}
              </Table.Tbody>
            </Table>
          </ScrollArea>

          <Flex
            justify={typeDelivery === "NOI_CHUYEN" ? "space-between" : "end"}
            align={"center"}
            gap={"md"}
          >
            {/* {typeDelivery === "NOI_CHUYEN" ? (
              <Select
                label="Bộ phận giao hàng tiếp theo"
                placeholder="Bộ phận giao hàng tiếp theo"
                value={form.getValues()?.deliveryDepartment}
                data={BPGV}
                size="xs"
                w={300}
                {...form.getInputProps("deliveryDepartment")}
                onChange={(e) =>
                  form.setValues((prev) => ({
                    ...prev,
                    deliveryDepartment: e
                      ? e
                      : dataDeliverySelect[0]?.attribute15,
                  }))
                }
              />
            ) : (
              <></>
            )} */}
            <Flex gap={"md"} align={"center"}>
              <Checkbox
                label={"Giao hàng tại chỗ"}
                checked={form.getValues()?.isDeliveryOnSite}
                mt={20}
                onClick={() =>
                  form.setValues((prev) => ({
                    ...prev,
                    isDeliveryOnSite: !form.getValues()?.isDeliveryOnSite,
                    deliveryIdForCombine: null,
                    distance:
                      form.getValues()?.isDeliveryOnSite &&
                      typeDelivery !== "GHEP_DON"
                        ? dataAddress.reduce((sum, i) => {
                            return sum + i.distanceMeters;
                          }, 0)
                        : 0,
                    distanceTotal:
                      form.getValues()?.isDeliveryOnSite &&
                      typeDelivery !== "GHEP_DON"
                        ? dataAddress.reduce((sum, i) => {
                            return sum + i.distanceMeters;
                          }, 0)
                        : 0,
                    estimatedTime:
                      form.getValues()?.isDeliveryOnSite &&
                      typeDelivery !== "GHEP_DON"
                        ? dataAddress.reduce((sum, i) => {
                            return sum + i.durationSeconds;
                          }, 0)
                        : 0,
                    deliveries: dataAddress?.map((i) => ({
                      deliveryId: Number(i.id),
                      durationEstimated: form.getValues()?.isDeliveryOnSite
                        ? i.durationSeconds
                        : 0,
                      distanceEstimated: form.getValues()?.isDeliveryOnSite
                        ? i.distanceMeters
                        : 0,
                      isPayroll: false,
                    })),
                  }))
                }
                style={{ cursor: "pointer" }}
              />
              <Divider size="sm" orientation="vertical" />
              <TextInput
                label="Tổng khoảng cách"
                placeholder="Bấm nút tính khoảng cách để hiển thị"
                value={`${(
                  Number(form.getValues()?.distanceTotal) / 1000
                ).toFixed(2)} Km`}
                variant="filled"
                readOnly
                size="xs"
              />
              <TextInput
                label="Thời gian giao ước tính"
                placeholder="Bấm nút tính khoảng cách để hiển thị"
                value={`${Math.floor(
                  Number(form.getValues()?.estimatedTime) / 3600,
                )} giờ - ${Math.floor(
                  (Number(form.getValues()?.estimatedTime) % 3600) / 60,
                )} phút`}
                variant="filled"
                readOnly
                size="xs"
              />
            </Flex>
          </Flex>
        </>
      )}
      <Group
        justify="end"
        mt="md"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="button"
          color="gray"
          loading={visible}
          onClick={() => {
            modals.closeAll();
          }}
          leftSection={!visible ? <IconWindow size={18} /> : undefined}
        >
          Đóng
        </Button>
        <Button
          type="submit"
          color={"green"}
          loading={visible}
          leftSection={!visible ? <IconCheck size={18} /> : undefined}
        >
          Lưu
        </Button>
        <></>
      </Group>
    </Box>
  );
};

export default AssignmentOfInstallation;
